<!--选择模板配置-->
<template>
	<div>
		<el-dialog
			title="模板列表 (状态无效：配置模板→完成校验)"
			:visible.sync="dialogVisible"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			:show-close="false"
			width="970px"
		>
			<el-button type="primary" size="small" class="can-swipe" :class="{ 'swipe-over': scanState === 1 }" @click="newBuildDispose">新建配置</el-button>
			<el-button type="primary" size="small" @click="originSlice">原卷切块</el-button>
			<el-table :data="tableData" border style="width: 100%" v-loading="tableLoading">
				<el-table-column fixed prop="pkId" label="ID" width="70" align="center"> </el-table-column>
				<el-table-column prop="areaPartOf" label="父版本ID" width="90" align="center"> </el-table-column>
				<el-table-column prop="areaName" label="版本名称" width="120" align="center" show-overflow-tooltip>
					<template slot-scope="scope">
						<el-input v-model="scope.row.areaName" placeholder="" type="text" @keydown.native.enter="enterChange(scope.row)"></el-input>
					</template>
				</el-table-column>
				<el-table-column prop="remarks" label="描述" width="150" align="center">
					<template slot-scope="scope">
						<input type="text" v-model="scope.row.description" placeholder="" class="description-style" @keydown.enter="enterChange(scope.row)" />
					</template>
				</el-table-column>
				<el-table-column prop="updateId" label="已识别" width="70" align="center" />
				<el-table-column prop="deleted" label="状态" width="80" align="center">
					<template slot-scope="scope">
						<span style="color:red;font-weight: bolder" :class="{ active: scope.row.deleted == 0 }">
							{{ scope.row.deleted == 0 ? '有效' : '无效' }}
						</span>
					</template>
				</el-table-column>
				<el-table-column prop="appendInfo" label="组号" width="110" align="center">
					<template slot-scope="scope">
						<el-select v-model="scope.row.appendInfo" placeholder="请选择" @change="selectGroup($event, scope.row)">
							<el-option v-for="item in groupList" :key="item" :label="item" :value="item"> </el-option>
						</el-select>
					</template>
				</el-table-column>
				<el-table-column fixed="right" label="操作" width="160" align="center">
					<template slot-scope="scope">
						<div class="operate-wrap">
							<el-link type="primary" style="color: #009688" @click="equipTemplate(scope.$index)">配置</el-link>
							<el-link type="primary" style="color: #009688" @click="overviewTemplate(scope.row)">预览</el-link>
							<el-link type="success" style="color: #009688" @click="cloneTemplate(scope.row)">克隆</el-link>
							<el-link type="danger" @click="deleteTemplate(scope.row)">删除</el-link>
						</div>
					</template>
				</el-table-column>
			</el-table>
		</el-dialog>
	</div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
export default {
	name: 'chose-edit',
	data() {
		return {
			//dialog 状态
			dialogVisible: true,
			//no use
			editOverviewState: false,
			//loading
			tableLoading: true,
			//数据
			tableData: [],
			//组列表
			groupList: [],
			groupListDetail: [],
			//预览图片列表
			overviewList: [],
			//所有的ppi
			allPpis: [],
			query: this.$route.query,
			//no use
			choseRowIndex: null,
			//类型
			dotType: { title: [], category: [], examNo: [], subjective: [], objective: [] },
			//当权页
			currentPage: 1,
			//图片列表
			totalImgList: [],
			//no use
			versionId: null,
			//no use
			imgSrc: '',
			//选择要配置的table list 索引
			equipIndex: 0,
			//题块
			activeTab: 'title',
			//阅卷完成情况下  是不能继续配置的
			scanState: 0,
			//是否 原卷 状态
			originFlag: false
		}
	},
	watch: {
		tempFlushData(val) {
			this.getTemplateList(true, val.state)
		}
	},
	computed: { ...mapGetters('examination/configation', ['tempFlushData']) },
	created() {
		this.getTemplateList()
	},
	methods: {
		...mapActions('examination/databases', ['set', 'get', 'del']),
		...mapMutations('examination/configation', [
			'setDotType',
			'setTypeLack',
			'setTemObjFormat',
			'setObjCanKeyDel',
			'setTempRectTitle',
			'setTempChooseList',
			'setTempExamNoType',
			'setTempOriginFlag',
			'setGroupListDetail',
			'setTempEditImgInfo',
			'setTempRectObjective',
			'setTempRectSliceList',
			'setTempRectExamNoInfo',
			'setTempRectSubjective',
			'setHandleSliceOriginClick'
		]),
		enterChange(val, isSelGroup = false, groupVal = null) {
			let remarks = val.remarks
			if (remarks === '') {
				val.remarks = JSON.stringify({ desc: val.description })
			} else {
				let nowMark = JSON.parse(remarks)
				nowMark.desc = val.description
				val.remarks = JSON.stringify(nowMark)
			}
			delete val['description']
			if (isSelGroup) val.appendInfo = groupVal
			const params = {
				subjectId: this.query.subjectId,
				examId: this.query.examId,
				versionId: val.pkId,
				ppiId: val.pkId,
				ppiStr: JSON.stringify(val)
			}
			this.$post('Cv/refreshPpi', params).then(res => {
				if (res.code === 200) {
					this.$message({ type: 'success', message: '更新成功' })
					this.getTemplateList()
				}
			})
		},
		// 选取组号
		selectGroup(selVal, item) {
			this.enterChange(item, true, selVal)
		},
		// 新建配置
		newBuildDispose() {
			// 有组 必须有图片
			if (this.groupList.length === 0) {
				this.$message.error('没有上传答题卡，请配置')
				return false
			}
			if (this.scanState === 1) {
				this.$message.error('已完成阅卷，不可新建配置')
				return false
			}
			const params = {
				examId: this.query.examId,
				subjectId: this.query.subjectId
			}
			this.$post('Cv/newPpiVersion', params).then(res => {
				this.refershPaper(res.data)
			})
		},
		// 原卷切块
		originSlice() {
			if (!this.originFlag) {
				this.$message.error('没有原卷，请配置')
				return false
			}
			this.setTempOriginFlag(this.originFlag)
			this.setHandleSliceOriginClick({ state: this.scanState === 1 })
			this.handleEquipTemplate(0, true)
		},
		//新建图片，并更新图片
		refershPaper(val) {
			val.appendInfo = [...this.groupList][0]
			const params = {
				subjectId: this.query.subjectId,
				examId: this.query.examId,
				versionId: val.pkId,
				ppiId: val.pkId,
				ppiStr: JSON.stringify(val)
			}
			this.$post('Cv/refreshPpi', params).then(() => {
				this.getTemplateList(false)
			})
		},
		// 获取列表
		async getTemplateList(equipState = false, state = true) {
			const params = {
				examId: this.query.examId,
				subjectId: this.query.subjectId
			}
			this.$get('Cv/index3', params).then(async res => {
				this.allPpis = JSON.parse(JSON.stringify(res.data.ppis))
				this.scanState = res.data.scanState
				let getPpis = res.data.ppis
				this.groupListDetail = res.data.paperImgs
				this.setGroupListDetail(res.data.paperImgs)
				this.tableData = []
				getPpis.forEach(responce => {
					if (responce.areaType === 0) {
						responce.description = ''
						if (responce.remarks !== '') {
							responce.description = JSON.parse(responce.remarks).desc
						}
						this.tableData.push(responce)
					}
				})
				let imgList = []
				res.data.paperImgs.map(resp => {
					// 4 原卷  2 答题卡
					if (resp.type === 4) {
						this.originFlag = true
					} else if (resp.type === 2) {
						imgList.push(resp.pageCode)
					}
				})
				this.groupList = new Set(imgList)
				this.totalImgList = res.data.paperImgs
				this.tableLoading = false
				this.setTemObjFormat(res.data.objFormat)
				const choseRowIndex = await this.get({ dbName: 'database', path: 'tempCurrentPageIndex', defaultValue: 0, user: true })
				this.setObjCanKeyDel(true)
				if (equipState) this.handleEquipTemplate(choseRowIndex, state)
			})
		},
		// 配置
		equipTemplate(index, state = true) {
			if (this.scanState === 1) {
				this.$message.error('已完成阅卷，不可配置')
				return false
			}
			this.handleEquipTemplate(index, state)
		},
		handleEquipTemplate(index, state) {
			this.equipIndex = index
			this.set({ dbName: 'database', path: 'tempCurrentPageIndex', value: index, user: true })
			let typeTitle = [],
				typeExamNo = [],
				typeObjective = [],
				typeSubjective = [],
				typeChooseList = [],
				typeLackList = [],
				typeSliceList = []
			this.allPpis
				.filter(res => res.areaPartOf === this.tableData[index].pkId)
				.forEach(resp => {
					switch (resp.areaType) {
						case 2:
							typeTitle.push(resp)
							break
						case 4:
							this.dotType.category.push(resp)
							break
						case 8:
							typeExamNo.push(resp)
							this.setTempExamNoType(JSON.parse(resp.remarks).type)
							break
						case 16:
							typeObjective.push(resp)
							break
						case 32:
							if (JSON.parse(resp.remarks).isLikeSub) {
								typeChooseList.push(resp)
							} else {
								typeSubjective.push(resp)
							}
							break
						case 64:
							typeSliceList.push(resp)
							break
						case 128:
							typeChooseList.push(resp)
							break
						case 256:
							typeLackList.push(resp)
							break
					}
				})
			this.dotType.title = typeTitle
			this.dotType.examNo = typeExamNo
			this.dotType.objective = typeObjective
			this.dotType.subjective = typeSubjective
			this.dotType.choose = typeChooseList
			this.dotType.lack = typeLackList
			this.dotType.slice = typeSliceList
			this.setTempRectTitle(this.dotType.title)
			this.setTempRectExamNoInfo(this.dotType.examNo)
			this.setTypeLack(this.dotType.lack)
			this.setTempChooseList(this.dotType.choose)
			this.setTempRectObjective({ val: this.dotType.objective, state })
			this.setTempRectSubjective(this.dotType.subjective)
			this.setTempRectSliceList(this.dotType.slice)
			this.setDotType(this.dotType)
			this.operateCurrentImg()
			this.dialogVisible = false
		},
		// 解析当前的图片
		operateCurrentImg() {
			let editImgList = [],
				sliceImgList = []
			this.groupListDetail.forEach(resp => {
				if (Number(this.tableData[this.equipIndex].appendInfo) === resp.pageCode && resp.type === 2 && this.activeTab !== 'slice') {
					editImgList.push(resp.remark)
				} else if (resp.pageCode === 1 && resp.type === 4) {
					sliceImgList.push(resp.remark)
				}
			})
			const infos = {
				currentTable: this.tableData[this.equipIndex],
				list: editImgList,
				len: editImgList.length,
				versionId: this.tableData[this.equipIndex].pkId,
				originList: sliceImgList
			}
			this.setTempEditImgInfo(infos)
		},
		// 预览
		overviewTemplate(row) {
			let totalImg = []
			this.totalImgList.forEach((res, index) => {
				if (res.pageCode == row.appendInfo) {
					totalImg.push(
						this.baseUrl +
							`/Cv/getRectOn?areaType=0&pading=0&examId=${this.query.examId}&subjectId=${this.query.subjectId}&version=${row.pkId}&page=${index +
								1}`
					)
				}
			})
			this.$viewerApi({
				images: totalImg
			})
		},
		// 删除
		deleteTemplate(row) {
			if (this.scanState === 1) {
				this.$message.error('已完成阅卷，不可删除')
				return false
			}
			const params = {
				examId: row.examId,
				subjectId: row.examSubjectId,
				versionId: row.pkId
			}
			this.$confirm('是否删除当前配置?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					this.$get('Cv/delPpiVersion', params).then(res => {
						if (res.code === 200) {
							this.$message.success('删除成功!')
						} else {
							this.$message.error(res.msg)
						}
						this.tableLoading = true
						this.getTemplateList()
					})
				})
				.catch(() => {
					this.$message({ type: 'info', message: '已取消删除' })
				})
		},
		// 克隆
		cloneTemplate(row) {
			if (this.scanState === 1) {
				this.$message.error('已完成阅卷，不可克隆')
				return false
			}
			const params = {
				examId: this.query.examId,
				subjectId: this.query.subjectId,
				versionId: row.pkId
			}
			this.$post('Cv/clonePpiVersion', params).then(() => {
				this.tableLoading = true
				this.getTemplateList()
			})
		}
	},
	filters: {
		fixDesc(val) {
			if (val.remarks) return JSON.parse(val.remarks).desc
		}
	}
}
</script>

<style scoped lang="less">
.operate-wrap {
	display: flex;
	justify-content: space-between;
}
.edit-over-view {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: black;
	z-index: 2009;
	background: rgba(0, 0, 0, 0.8);
	display: flex;
	justify-content: center;
	align-items: center;
	.iconfont {
		position: absolute;
		right: 20px;
		top: 20px;
		color: white;
		font-size: 40px;
		&:hover {
			cursor: pointer;
		}
	}
	.preview-img-wrap {
		width: 90%;
		height: 90%;
		background: white;
		border-radius: 8px;
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;
		img {
			max-width: 100%;
			max-height: 100%;
		}
		&:hover .iconfont {
			display: block;
		}
		.iconfont {
			display: none;
			position: absolute;
			top: 50%;
			font-size: 50px;
			color: black;
		}
		.iconjiantouzuo {
			left: 20px;
		}
		.iconjiantouyou {
			right: 20px;
		}
	}
}
.description-style {
	width: 80%;
	border-radius: 4px;
	border: 1px solid #dcdfe6;
	color: #606266;
	display: inline-block;
	font-size: inherit;
	height: 40px;
	line-height: 40px;
	outline: 0;
	padding: 0 15px;
	transition: border-color 0.2s;
	&:active {
		border: 1px solid #1951d3;
	}
}
.active {
	color: #009688 !important;
}
.views {
	position: fixed;
	z-index: 2002;
}
.can-swipe {
	margin: 0 10px 8px 0;
	background-color: #009688;
}
.swipe-over {
	background-color: #686e6e;
	border: 1px solid #686e6e;
}
</style>
